import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/common/loading.service';

@Injectable()
export class HttpLoadingRequestInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isAssetsRequest = req.url.includes('assets/');
    const shouldLoading = this.loadingService.shouldLoading(req.urlWithParams);

    if (
      (shouldLoading || this.loadingService.shouldActiveInEveryUrl()) &&
      !isAssetsRequest
    ) {
      this.loadingService.show(req.urlWithParams);
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!isAssetsRequest) {
          this.loadingService.hide(req.urlWithParams);
        }
      })
    );
  }
}
